import { render } from "./MIInvestmentDetailPage.vue?vue&type=template&id=0683ffcb&scoped=true"
import script from "./MIInvestmentDetailPage.vue?vue&type=script&lang=js"
export * from "./MIInvestmentDetailPage.vue?vue&type=script&lang=js"

import "./MIInvestmentDetailPage.vue?vue&type=style&index=0&id=0683ffcb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0683ffcb"

export default script